/**
 * SIL-1617 - the onboarding wizard hands the user to the import review page and
 * back, so the uploaded batch ids survive in sessionStorage. The wizard
 * rehydrates counts from GET /import/batches/:id/review (the DB is the truth).
 */
const KEY = 'sx_onboarding_import_batches';

export interface StoredBatch {
  batchId: string;
  label: string;
}

export function loadStoredBatches(): StoredBatch[] {
  try {
    const v = JSON.parse(sessionStorage.getItem(KEY) ?? '[]') as unknown;
    return Array.isArray(v)
      ? v.filter((b): b is StoredBatch => !!b && typeof (b as StoredBatch).batchId === 'string')
      : [];
  } catch {
    return [];
  }
}

export function saveStoredBatches(batches: StoredBatch[]): void {
  sessionStorage.setItem(KEY, JSON.stringify(batches));
}

export function addStoredBatch(b: StoredBatch): void {
  saveStoredBatches([...loadStoredBatches().filter((x) => x.batchId !== b.batchId), b]);
}

export function removeStoredBatch(batchId: string): void {
  saveStoredBatches(loadStoredBatches().filter((x) => x.batchId !== batchId));
}

export function clearStoredBatches(): void {
  sessionStorage.removeItem(KEY);
}
